import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearUserNotesAction, clearSelectedNoteAction, getUserNotesAction } from '../../redux/actions/notesActions';

const useFetchUserNotes = () => {
  const dispatch = useDispatch();
  const search = useSelector((state) => state.notes?.userNotesSearch);
  const userNotes = useSelector((state) => state.notes?.userNotes);
  const loading = useSelector((state) => state.notes?.userNotesLoading);

  const fetchUserNotes = useCallback(async () => {
    await dispatch(getUserNotesAction(search));
  }, [dispatch, search]);

  useEffect(() => {
    fetchUserNotes();
  }, [fetchUserNotes]);

  useEffect(() => {
    return () => {
      dispatch(clearUserNotesAction());
      dispatch(clearSelectedNoteAction());
    };
  }, [dispatch]);

  const refresh = () => {
    fetchUserNotes();
  };

  return { loading, userNotes, refresh };
};

export default useFetchUserNotes;
